'use client' // Error boundaries must be Client Components

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  // Check if this error was already handled silently by our SilentErrorBoundary
  if ((error as any).__silentlyHandled) {
    // Don't show the error page, just return null or a minimal fallback
    return null
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-srperrito-dark text-srperrito-cream p-4">
      <h2 className="text-4xl font-bold mb-4">¡Algo salió mal!</h2>
      <p className="text-xl mb-8">Ha ocurrido un error inesperado</p>
      <button
        onClick={() => reset()}
        className="px-6 py-3 bg-srperrito-cream text-srperrito-dark font-bold rounded-lg hover:bg-srperrito-cream/90 transition-colors"
      >
        Intentar de nuevo
      </button>
    </div>
  )
}
